import { render, staticRenderFns } from "./RevisionEdit.vue?vue&type=template&id=22ee6750"
import script from "./RevisionEdit.vue?vue&type=script&lang=js"
export * from "./RevisionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports